import http from '@/util/http'

export default {

	changeCardValidDate(cardNumber, cardType, cardValidDate) {
		let ftReq = {cardNumber: cardNumber, cardType: cardType, cardValidDate: cardValidDate}
		return http.post('/BillCreditCard/api/changeCardValidDate', ftReq);
		},
	permissionValidation(){
		return http.get('/BillCreditCard/api/permissionValidation');
	}
}



// WEBPACK FOOTER //
// ./src/api/billCreditCard/billCreditCardApi.js